import { render, staticRenderFns } from "./transferBalanceRecord.vue?vue&type=template&id=a9901c34&scoped=true&"
import script from "./transferBalanceRecord.vue?vue&type=script&lang=js&"
export * from "./transferBalanceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9901c34",
  null
  
)

export default component.exports